"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BOOKING_REFUSALS = exports.seatBookingSchema = exports.cancelBookingSchema = exports.updateBookingSchema = exports.createBookingSchema = exports.BOOKING_OVERDUE_GRACE_MINUTES = exports.BOOKING_STATUSES = void 0;
const zod_1 = require("zod");
/**
 * Bookings — the advance booking of a device (docs/WAVE2-DESIGN.md §1).
 *
 * Named Booking, not Reservation: the SPEC uses "reservation" to mean a LIVE
 * sitting everywhere (BillKind.RESERVATION, ReservationType = billing mode),
 * and §5.7 itself calls the no-show report the "Time Out Bookings Report".
 *
 * Writes run under `sessions.manage` — the person taking bookings is the
 * person who opens sessions. Reads are authenticated but ungated, like the
 * Device List every employee needs.
 */
exports.BOOKING_STATUSES = ['BOOKED', 'SEATED', 'CANCELLED', 'NO_SHOW'];
/** Minutes past startsAt before a BOOKED booking reads as overdue. */
exports.BOOKING_OVERDUE_GRACE_MINUTES = 15;
exports.createBookingSchema = zod_1.z
    .object({
    deviceId: zod_1.z.string().trim().min(1).max(64),
    /** Walk-in party name; exactly one of these two, like Tab. */
    visitorName: zod_1.z.string().trim().min(1).max(80).optional().nullable(),
    customerAccountId: zod_1.z.string().trim().min(1).max(64).optional().nullable(),
    /** ISO datetime WITH offset — the client's wall clock is not trusted bare. */
    startsAt: zod_1.z.iso.datetime({ offset: true }),
    durationMinutes: zod_1.z
        .number()
        .int()
        .min(15)
        .max(24 * 60),
    partySize: zod_1.z.number().int().min(1).max(64).optional().nullable(),
    note: zod_1.z.string().trim().max(300).optional().nullable(),
})
    .refine((value) => Boolean(value.visitorName) !== Boolean(value.customerAccountId), {
    message: 'Name the party either as a walk-in or as an account — exactly one.',
    path: ['visitorName'],
});
/**
 * PATCH while BOOKED only. Declared explicitly — never `.partial()`, which
 * keeps zod defaults and rewrites omitted fields (the wave-1 review finding).
 */
exports.updateBookingSchema = zod_1.z.object({
    startsAt: zod_1.z.iso.datetime({ offset: true }).optional(),
    durationMinutes: zod_1.z
        .number()
        .int()
        .min(15)
        .max(24 * 60)
        .optional(),
    partySize: zod_1.z.number().int().min(1).max(64).optional().nullable(),
    note: zod_1.z.string().trim().max(300).optional().nullable(),
});
exports.cancelBookingSchema = zod_1.z.object({
    reason: zod_1.z.string().trim().max(200).optional().nullable(),
});
/** Convert a booking into a real sitting; optionally attach to an open tab. */
exports.seatBookingSchema = zod_1.z.object({
    tabId: zod_1.z.string().trim().min(1).max(64).optional().nullable(),
});
/**
 * Refusal codes the staff screens discriminate on. `booking_overlap` carries
 * `details` naming the conflicting booking id and window; a create that
 * merely collides with a LIVE session succeeds with
 * `warnings: ['live_session_overlap']` — walk-ins run long, and the collision
 * resurfaces at seat time as `device_busy`.
 */
exports.BOOKING_REFUSALS = [
    'booking_not_found',
    'booking_not_open',
    'booking_overlap',
    'device_not_found',
    'customer_not_found',
];
//# sourceMappingURL=bookings.js.map